import React, { FC, memo, lazy, Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import { AdminProvider } from "application/contexts/admin/adminContext";
import { IOrderProviderRef } from "modules/order/presentation/OrderProvider";
import RequestDocument from "components/requestDocument/RequestDocument";

const Home = lazy(() => import("areas/home/Home"));
const Catalog = lazy(() => import("areas/_catalog/Catalog"));
const PosPaid = lazy(() => import("areas/cashless/posPaid/PosPaid"));
const PrePaid = lazy(() => import("areas/cashless/prePaid/Prepaid"));
const NominalCashless = lazy(() => import("areas/cashless/nominalCashless/NominalCashless"));
const OfflineRecharge = lazy(() =>
  import("areas/cashless/offlineRecharge/OfflineRecharge").then((module) => ({
    default: module.OfflineRecharge,
  }))
);
const StoresListPage = lazy(() =>
  import("areas/catalog/pages/storesListPageChurch/StoresListPage").then((module) => ({
    default: module.StoresListPage,
  }))
);
const Admin = lazy(() =>
  import("areas/admin/Admin").then((module) => ({
    default: module.Admin,
  }))
);
const WalletPage = lazy(() => import("areas/wallet/WalletPage"));

interface IRoutesPropes {
  orderProvider: React.RefObject<IOrderProviderRef>;
}

const Routes: FC<IRoutesPropes> = memo(({ orderProvider }) => {
  return (
    <Suspense fallback={<div>Carregando...</div>}>
      <Switch>
        <Route exact path="/" component={Home} />

        <Route path="/catalog">
          <Switch>
            <Route exact path="/catalog">
              <StoresListPage />
            </Route>

            <Route path="/catalog/store/:storeId">
              <Catalog />
            </Route>
          </Switch>
        </Route>

        <Route path="/posPaid">
          <PosPaid orderProvider={orderProvider} />
        </Route>

        <Route path="/prePaid">
          <PrePaid orderProvider={orderProvider} />
        </Route>

        <Route path="/nominalCashless">
          <NominalCashless orderProvider={orderProvider} />
        </Route>

        <Route path="/offlineRecharge">
          <OfflineRecharge orderProvider={orderProvider} />
        </Route>

        <Route path="/validateDocument" component={RequestDocument} />

        <Route path="/admin">
          <AdminProvider>
            <Admin />
          </AdminProvider>
        </Route>

        <Route path="/wallet">
          <WalletPage orderProvider={orderProvider} />
        </Route>
      </Switch>
    </Suspense>
  );
});

export default Routes;